import React from 'react'

const Dashboard = () => <h1>RNWBL Dashboard</h1>

export default Dashboard
